
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/page/[number]",
      function () {
        return require("private-next-pages/news/page/[number].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/page/[number]"])
      });
    }
  